import api from '@/api/api';

const state = {
    platforms: [],
    currentPlatforms: [],
    testRunsPlatforms: [],
};

const getters = {
    platforms: state => state.platforms,
    platformByName: state => (platform, version) => state.platforms.find(item => item.platform == platform && item.version == version),
    currentPlatforms: state => state.currentPlatforms,
    testRunsPlatforms: state => state.testRunsPlatforms,
};

const mutations = {
    SET_PLATFORMS(state, platforms) {
        state.platforms = platforms;
    },
    SET_CURRENT_PLATFORMS(state, currentPlatforms) {
        state.currentPlatforms = currentPlatforms;
    },
    SET_TEST_RUNS_PLATFORMS(state, platforms) {
        state.testRunsPlatforms = platforms;
    },
    CLEAR_TEST_RUNS_PLATFORMS(state) {
        state.testRunsPlatforms = [];
    },
};

const actions = {
    /**
     * Fetch all platforms and save it to state.
     * @return {Promise} result.
     */
    async fetchPlatforms({ commit, getters }) {
        if (getters.platforms.length > 0) return;
        try {
            const platforms = await api.platforms.fetchAll();
            commit('SET_PLATFORMS', platforms);
        } catch (error) {
            return Promise.reject('Error of platforms list fetching');
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
